import Core from '../Core'

export default (superclass) => class extends superclass {
  findUserWithEmail () {
    return Core.publicWrapper({
      name: 'findUserWithEmail',
      arguments: arguments,
      parameters: ['userEmail', 'onSuccess', 'onFailure', 'onComplete'],
      validations: [
        { name: 'userEmail', presence: true, type: 'string' },
      ],
    })
  }

  // deprecated
  getHome () {
    Core.logger.warn('(DeprecationWarning) getHome is deprecated and will be removed')

    return this._publicWrapperWithoutParameter('getHome', arguments)
  }

  // deprecated
  getCardDetails () {
    Core.logger.warn('(DeprecationWarning) getCardDetails is deprecated and will be removed')

    return this._publicWrapperWithoutParameter('getCardDetails', arguments)
  }

  // deprecated
  getRewards () {
    Core.logger.warn('(DeprecationWarning) getRewards is deprecated and will be removed')

    return this._publicWrapperWithoutParameter('getRewards', arguments)
  }

  // deprecated
  selectTargetReward () {
    Core.logger.warn('(DeprecationWarning) selectTargetReward is deprecated and will be removed')

    return Core.publicWrapper({
      name: 'selectTargetReward',
      arguments: arguments,
      parameters: ['reward', 'onSuccess', 'onFailure', 'onComplete'],
      validations: [
        { name: 'reward',
          presence: true,
          type: 'object',
          properties: [
            { name: 'id', presence: true, type: 'number', nan: false },
          ] },
      ],
    })
  }

  getLoyaltyPot () {
    return this._publicWrapperWithoutParameter('getLoyaltyPot', arguments)
  }

  getLoyaltyPotRefunds () {
    return Core.publicWrapper({
      name: 'getLoyaltyPotRefunds',
      arguments: arguments,
      parameters: ['transferPaymentId', 'onSuccess', 'onFailure', 'onComplete'],
      validations: [
        { name: 'transferPaymentId', presence: true, type: 'number', nan: false },
      ]
    })
  }

  applyCode () {
    return Core.publicWrapper({
      name: 'applyCode',
      arguments: arguments,
      parameters: ['code', 'onSuccess', 'onFailure', 'onComplete'],
      validations: [
        { name: 'code', presence: true, type: 'string' },
      ]
    })
  }

  createZendesk () {
    return Core.publicWrapper({
      name: 'createZendesk',
      arguments: arguments,
      parameters: ['title', 'text', 'receiptUuid', 'onSuccess', 'onFailure', 'onComplete'],
      validations: [
        { name: 'title', type: 'string' },
        { name: 'text', presence: true, type: 'string' },
        { name: 'receiptUuid', type: 'string' },
      ]
    })
  }
}
